import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanActivateLivePageGuard implements CanActivate {
  constructor() {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (environment.rallyPageEnabled) {
      return true;
    } else {
      const redirectURL = environment.production ? environment.corporateUrl : window.location.origin;
      window.location.href = redirectURL;
    }
    return false;
  }
}
